// Formatting for trips (spec 35). Dates are shown in Europe/London, the same
// calendar the API uses for dayIndex.

const TZ = "Europe/London";

export function formatTripDistance(m: number | null | undefined): string {
  if (m == null) return "0 km";
  const km = m / 1000;
  return km >= 100 ? `${Math.round(km)} km` : `${km.toFixed(1)} km`;
}

/** Gaps: metres under 1 km ("314 m"), else km ("1.4 km"). */
export function formatGapDistance(m: number): string {
  return m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(1)} km`;
}

export function formatTripElevation(m: number | null | undefined): string {
  return `${Math.round(m ?? 0).toLocaleString("en-GB")} m`;
}

export function formatTripDuration(s: number | null | undefined): string {
  if (!s || s <= 0) return "0m";
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

function dayParts(iso: string) {
  const d = new Date(iso);
  return {
    day: d.toLocaleDateString("en-GB", { timeZone: TZ, day: "numeric" }),
    month: d.toLocaleDateString("en-GB", { timeZone: TZ, month: "short" }),
    year: d.toLocaleDateString("en-GB", { timeZone: TZ, year: "numeric" }),
  };
}

/** "23 to 25 Oct 2026", "30 Oct to 2 Nov 2026", "23 Oct 2026". */
export function formatTripDates(startedAt: string | null, endedAt: string | null): string {
  if (!startedAt) return "No live activities";
  const a = dayParts(startedAt);
  const b = dayParts(endedAt ?? startedAt);
  if (a.year !== b.year) return `${a.day} ${a.month} ${a.year} to ${b.day} ${b.month} ${b.year}`;
  if (a.month !== b.month) return `${a.day} ${a.month} to ${b.day} ${b.month} ${b.year}`;
  if (a.day !== b.day) return `${a.day} to ${b.day} ${b.month} ${b.year}`;
  return `${a.day} ${a.month} ${a.year}`;
}

/** "Day 1 · Fri 23 Oct". */
export function formatTripDayLabel(dayIndex: number, startedAt: string): string {
  const date = new Date(startedAt).toLocaleDateString("en-GB", {
    timeZone: TZ,
    weekday: "short",
    day: "numeric",
    month: "short",
  });
  return `Day ${dayIndex + 1} · ${date.replace(",", "")}`;
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString("en-GB")} ${n === 1 ? one : many}`;
}
